import { useMemo } from 'react';
import { Stack } from '@mui/material';
import { Flow } from '@thive/fddm-types';

import { getFlowEndDetails } from '../helpers';
import { FlowEnd } from './FlowEnd';

type Props = {
  /** Several flows (multi-edit) show the ends they share, 'Mixed' for the others */
  flows: Flow[];
};

export function FlowDirection({ flows }: Props) {
  const { source, destination } = useMemo(
    () => ({
      source: getFlowEndDetails(flows.map(({ sourceAreaOrFlowStopId }) => sourceAreaOrFlowStopId)),
      destination: getFlowEndDetails(
        flows.map(({ destinationAreaOrFlowStopId }) => destinationAreaOrFlowStopId),
      ),
    }),
    [flows],
  );

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap={1}
      color='neutral.main'
      width='100%'
      marginTop={1}
      flexWrap='wrap'
    >
      <FlowEnd name={source.name} loadHandlingType={source.loadHandlingType} />
      —
      <FlowEnd name={destination.name} loadHandlingType={destination.loadHandlingType} />
    </Stack>
  );
}
